import { render, staticRenderFns } from "./commentList.vue?vue&type=template&id=ed9636aa&scoped=true"
import script from "./commentList.vue?vue&type=script&lang=js"
export * from "./commentList.vue?vue&type=script&lang=js"
import style0 from "./commentList.vue?vue&type=style&index=0&id=ed9636aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed9636aa",
  null
  
)

export default component.exports